export const LOCAL_STORAGE_KEYS = {
  accessToken: "access_token",
  sidebar_menu: "sidebar_menu",
  loginUserDetails: "loginUserDetails",
  selectedCompanyId: "selectedCompanyId",
  device_fingerprint: "device_fingerprint",
};

export const url = {
  login: "/auth/login",
  subscriptionplan: "/layout/subscription-plans",
  subscriptionhub: "/layout/subscription",
  signUp: "/auth/register",
  sessionExpired: "/auth/session-expired",
  onboarding: "/onboarding",
  dashboard: "/layout/dashboard",
  campaign: "/layout/campaign",
  campaignDetails: "/layout/campaign/campaign-details",
  videoDetails: "/layout/campaign/campaign-details/video-detail",

  script: "/layout/script-screenplay",
  moodboard: "/layout/moodboard/",
  entityEdit: "/layout/moodboard/entity-edit/",
  storyboard: "/layout/shotlist-storyboard/",
  storyboardGate: "/layout/storyboard-gate/",
  frameGen: "/layout/shotlist-storyboard/frame-gen/",
  productionVideo: "/layout/production-video/",
  sonicLayer: "/layout/sonic-layer/",
  assetVideoGallary: "/video-gallary",
  billing: "layout/settings-billing",
  workspace: "/workspace/",
};

export const assetName = {
  concept: "Concept Manifest",
  script: "Script Screenplay",
  moodboard: "Moodboard",
  storyboard: "Storyboard",
  video: "AI Visual",
  aiVisual: "AI Visual",
  sound: "Sound",
  Preview: "Preview",
};

export const agent_name = {
  stage00CampaignSoul: "stage_00_campaign_soul",
  stage10ConceptManifest: "ConceptManifest",
  stage2c1ScriptReview: "2c.1-script-review",
  scriptScreenplay: "ScriptScreenplay",
};

export const prompt_type = {
  stage00BriefConversation: "0b_brief_conversation",
  stage1aConversationAgent: "1a-conversation-agent",
  stage2c1ScriptReview: "2c.1-script-review",
  scriptScreenplay: "ScriptScreenplay",
};

export const fps_master_list = [
  { id: 24, name: "24 fps" },
  { id: 30, name: "30 fps" },
  { id: 60, name: "60 fps" },
  { id: 90, name: "90 fps" },
  { id: 120, name: "120 fps" },
  { id: 144, name: "144 fps" },
];

export const asset_status = {
  approved: "Approved",
  pending: "Pending",
  generated: "Generated",
  inProgress: "In Progress",
  readyForReview: "Ready for Review",
  waitingForApproval: "Waiting For Approval",
  notStarted: "Not Started",
  feedbackLoop: "Feedback Loop",
};

export const videoManifestMode = {
  conversational: "conversational",
  guided: "guided",
};

export const defaultCountryCode = "+91";
export const defaultCountryCodeId = "2";
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE_LIST = [10, 20, 50, 100];

export const APIURL = {
  //#region Master List
  industryList: "/master-list/industry",
  roleList: "/master-list/role",
  roleListtoinvite: "/master-list/roles",
  targetAudience: "/master-list/target-audience",
  videoType: "/master-list/video-type",
  toneAndStyle: "/master-list/tone-style",
  aiModel: "/master-list/aimodels",
  platforms: "/master-list/platforms",
  scriptType: "/master-list/script-types",
  audioDeliveryStyle: "/master-list/audio-delivery-style",
  visualStyle: "/master-list/visual-style",
  setups: "/master-list/setups",
  imageStyle: "/master-list/image-styles",
  conceptManifectMaster: "/master-list/concept-manifest-masters",
  scriptOptions: "/master-list/script-options",
  assetApproved: "/campaign/approved-asset",
  entityRefType: "/master-list/entity-ref-types",
  entityGenOptions: "/master-list/entity-gen-options",
  fetchParameters: "/master-list/fetch-prameters",
  scheduleCronJobStatus: "/schedulecronjobs/job-status",
  videoJobStatus: "/schedulecronjobs/video-job-status",
  //#endregion

  //#region User Login / Register
  countryList: "/master-list/country",
  // userLogin: "/users/login-request",
  // verifyLoginOTP: "/users/verify-login-otp",

  loginWithMagicLink: "/users/send-magic-link",
  verifyMagicLink: "/users/verify-magic-link",

  preCheckUser: "/users/precheck",
  // userSignUp: "/users/signup",
  userRegistrationVerifyOTPAndUserSignup: "/users/signup",
  // UserRegistrationCompanyDetails: "/users/company-data",
  UserOnboarding: "/users/company-data-onboard",
  basicDetailsUpdate: "/users/basic-detail-update",
  inviteUsers: "/users/invite-users",
  getInviteDetails: "/users/invitation",
  acceptInvite: "/users/invitation/accept/v2",
  declineInvite: "/users/invitation/reject/v2",
  resendInvitationByEmail: "/users/invitation/resend-by-email",
  companyUserList: "/users/company-user-list",
  teamMembers: "/users/team-members",
  teamMemberInvites: "/users/team-members/invites",
  companyDetail: "/users/company-detail",
  creditBalance: "/users/fetch-credits",
  myorganizations: "/users/myorganizations",
  exitorganizations: "/users/exitorganizations",
  usersdetail: "/users/detail",
  updateuserprofile: "/users/updateprofile",
  //#endregion

  //#region Knowledge Base
  knowledgeBaseSave: "/users/company-knowledge-base",
  //#endregion

  //#region External Share
  externalShareCreate: "/external-share/create",
  externalShareAccessUsers: "/external-share/get/access/users",
  externalShareHeartbeat: "/external-share/heartbeat",
  externalShareLogin: "/external-share/login",
  externalShareDetails: "/external-share/details",
  externalShareConceptGet: "/external-share/concept/get",
  externalShareScriptGet: "/external-share/script/get",
  externalShareMoodboardGet: "/external-share/moodboard/get",
  externalShareMoodboardGetV2: "/external-share/moodboard/get/v2",
  externalShareStoryboardGet: "/external-share/storyboard/get",
  externalShareVideoGet: "/external-share/video/get",
  externalShareSoundGet: "/external-share/sound/get",
  externalShareCancelRequest: "/external-share/cancel-request",
  externalShareSendReminder: "/external-share/send-reminder",
  externalShareAssetFeedbackList: "/external-share/asset-feedback/list",
  externalShareAssetFeedbackCounts: "/external-share/asset-feedback/counts",
  externalShareAssetFeedbackSend: "/external-share/asset-feedback/send",
  externalShareAssetFeedbackUpdate: "/external-share/asset-feedback/update",
  externalShareAssetFeedbackDelete: "/external-share/asset-feedback/delete",
  externalShareAssetFeedbackResolve: "/external-share/asset-feedback/resolve",
  externalShareAssetFeedbackReactionToggle:
    "/external-share/asset-feedback/reaction/toggle",
  externalShareAssetFeedbackRead: "/external-share/asset-feedback/read",
  externalShareFeedbackChatSend: "/external-share/feedback-chat/send",
  externalShareFeedbackChatMessages: "/external-share/feedback-chat/messages",
  externalShareFeedbackChatRequestChange:
    "/external-share/feedback-chat/request-for-change",
  externalShareMoodboardFeedbackSave: "/external-share/moodboard-feedback/save",
  externalShareScriptFeedbackSave: "/external-share/script-feedback/save",
  externalShareShotlistFeedbackSave: "/external-share/shotlist-feedback/save",
  externalShareAivisualFeedbackSave: "/external-share/aivisual-feedback/save",
  externalShareTimeline: "/external-share/timeline",
  externalShareTimelineScript: "/external-share/timeline/script",
  externalShareTimelineShotlist: "/external-share/timeline/shotlist",
  externalShareTimelineVideox: "/external-share/timeline/videox",
  externalShareMoodboardPdfData: "/external-share/moodboard/pdf/get",
  externalShareStoryboardPdfData: "/external-share/storyboard/pdf/get",
  externalShareAssetApproved: "/external-share/approved-asset",
  externalEntityRefImageApproved: "/external-share/approved-image",
  externalShotImageApprove: "/external-share/approved-storyboard-img",
  externalShareGenerateLink: "/external-share/copy-link",
  externalShareVideoApprove: "/shotlist/video/approve/external",
  externalShareFeedbackDetails: "/external-share/feedback-details/get",
  externalShareAspectRatios: "/external-share/aspect-ratios",
  //#endregion

  //#region Dashboard APIs
  dashboardStats: "/dashboard/stats",
  dashCampaignList: "/dashboard/compaing-list",
  dashPersonaActivityFeed: "/dashboard/activity-logs",
  dashApprovalReqList: "/dashboard/approval-req-list",
  //#endregion

  //#region Campaign APIs
  createNewCampaign: "/campaign/create-new",
  CampaignList: "/campaign/list",
  campaignDetails: "/campaign/detail",
  campaignTeamList: "/campaign/campaign-team-members",
  campaignCompanyMembers: "/campaign/company-members",
  campaignAddTeamMember: "/campaign/add-team-member",
  campaignRemoveTeamMember: "/campaign/remove-team-member",
  camapaignHubStats: "/campaign/stats",
  campaignPresignedBriefUrls: "/campaign/presigned-brief-urls",
  campaignBriefUploadComplete: "/campaign/brief-upload-complete",
  campaignDelete: "/campaign/delete/",
  updateCampaignSoul: "/campaign/soul-update",
  campaignSoulAssetsPresignedUrls: "/campaign/soul-assets/presigned-urls",
  campaignSoulAssetsUploadComplete: "/campaign/soul-assets/upload-complete",
  updateCampaignBudget: "/campaign/update-budget",

  //#endregion

  //#region Video APIs
  conceptMenifectDetails: "/conceptnote/manifest/detail/",
  updateManifest: "/conceptnote/manifest/update",
  manifestReviewStart: "/conceptnote/manifest/review/start",
  manifestReviewChat: "/conceptnote/manifest/review/chat",
  manifestReviewMessages: "/conceptnote/manifest/review/messages",
  manifestReviewChangelog: "/conceptnote/manifest/review/changelog",
  videoAssetList: "/campaign/video/asset-list/",
  videoRecentActivity: "/campaign/video-activity/",
  videoStages: "/campaign/video-stages/",
  campaignVideoUpdateTitle: "/campaign-video/update-title",
  campaignVideoDelete: "/campaign-video/delete/",
  campaignVideoReset: "/campaign-video/reset-video",
  scriptAnalysisPresignedUrls: "/campaign-video/script-analysis-presigned-urls",
  scriptAnalysisUploadComplete:
    "/campaign-video/script-analysis-upload-complete",
  //#endregion

  //#region LLM / AI Chat
  llmConversationMessages: "/llm-conversation/messages",
  llmConversationChat: "/llm-conversation/chat",
  // llmConversations: "/llm-conversation/conversations",

  llmConversationById: "/llm-conversation/conversations/",
  llmConversationDeleteById: "/llm-conversation/conversations-delete/",
  //#endregion

  //#region Conversation Agent (block-based AI assistant)
  conversationAgentMessage: "/conversation-agent/message",
  conversationAgentResolveAction: "/conversation-agent/resolve-action",
  conversationAgentHistory: "/conversation-agent/history",
  //#endregion

  //#region ConceptX APIs
  conceptDetails: "/conceptnote/detail/",
  generateAIConcept: "/conceptnote/generate/req",
  createManualConcept: "/conceptnote/create-mannual",
  conceptFeedbackList: "/conceptnote/feedbacklist",
  approvedConceptNotes: "/conceptnote/approved-list",
  conceptDraftHistory: "/conceptnote/draft-history",
  //#endregion

  //#region Script Writer APIs
  // scriptInit: "/scriptscreenplay/initiate",
  scriptDetails: "/scriptscreenplay/detail/",
  scriptFetchByVideo: "/scriptscreenplay/fetch/",
  menifestBasicDetails: "/conceptnote/manifest/basic-detail/",
  generateAIScriptV2: "/scriptscreenplay/generate/req/v2",
  updateScriptScene: "/scriptscreenplay/update-scene",
  manualProcessing: "/scriptscreenplay/manual-processing",
  scriptAnalysisUpload: "/scriptscreenplay/script-analysis-upload",
  scriptReviewApprove: "/scriptscreenplay/script-review/approve",
  draftReadyForReview: "/scriptscreenplay/draft/ready-for-review",
  scriptVersionDelete: "/scriptscreenplay/draft-delete/",
  //#endregion

  //#region Moodboard APIs
  moodboardExcelData: "/moodboard/excel",
  entityVerifier: "/moodboard/entity-verifier/",
  entityConfirmation: "/moodboard/entity-confirmation",
  saveExtractedEntities: "/moodboard/save-entities/",
  moodboardEntityList: "/moodboard/entity-list/",
  moodboardEntityManualAdd: "/moodboard/entity-manual-add",
  moodboardEntitiesByVideo: "/moodboard/entities/",
  moodboardEntitiesByType: "/moodboard/entities/by-type",
  entityDetails: "/moodboard/entity-version/detail",
  editEntityOptions: "/master-list/entity-options",
  editRecipes: "/master-list/edit-recipes",
  editRecipesAiVisual: "/master-list/ai-visual/edit-recipes",
  moodboardEditRecipes: "/master-list/moodboard-edit-recipes",
  saveEntityAttributes: "/moodboard/entity-attributes/save",
  entityReferenceAdd: "/moodboard/entity-look-create",
  entityReferenceAddV2: "/moodboard/entity-look-create-v2",
  referenceImageUpload: "/moodboard/upload-img",
  referenceImageUploadV2: "/moodboard/upload-img-v2",
  moodboardUploadRefImage: "/moodboard/upload-refimage",
  entityImageGenerate: "/moodboard/generate-img-v2",
  entityRefImageApproved: "/moodboard/approved-image",
  approveImpactPreview: "/moodboard/approve-impact-preview",
  regenerateSiblingViews: "/moodboard/regenerate-sibling-views",
  // Library import: picker slots, new-option multi-import, single-view import
  entityImportLookViews: "/moodboard/entity-version/import-look-views",
  entityImportLibraryImages: "/moodboard/entity-version/import-library-images",
  entityLookViewImportLibraryImage:
    "/moodboard/entity-look-view/import-library-image",
  entityImageApprove: "/moodboard/entity-image/approve-reject",
  entityImageReference: "/moodboard/entity-image/reference",
  // + {variation_id}/reference — POST to flag, DELETE to clear
  entityImageVariationReference: "/moodboard/entity-image/variation/",
  entityImageReferences: "/moodboard/entity-image/references",
  entityImageReadyForReview: "/moodboard/image/ready-for-review",
  entityVersionLockUnlock: "/moodboard/entity-version/lock-unlock",
  entityVersionDisabled: "/moodboard/entity-version/disabled",
  entityImageDelete: "/moodboard/entity-image/delete",
  entityImageUpdateViewStatus: "/moodboard/entity-image/updateviewstatus",
  entityAutonomousDnaImage: "/moodboard/entity-version/autonomous-dna-image",
  entityVersionUpdateDescription:
    "/moodboard/entity-version/update-description",
  entityImageUpdateDescription: "/moodboard/entity-image/update-description",
  upscaleMoodboardImage: "/moodboard/upscale-moodboard-image",
  entityLookViewDelete: "/moodboard/entity-look-view/delete",
  entityLookViewCreate: "/moodboard/entity-look-view/create",
  entityLookViewDisable: "/moodboard/entity-look-view/disable",
  entityVersionOptionApprovedViews:
    "/moodboard/entity-version/option-approved-views",
  entityLookOptionStatus: "/moodboard/entity-look-option/status",
  variationRecipeFetch: "/moodboard/variation/recipe-fetch",
  /** Structure sync status / trigger — append `/{video_id}/{moodboard_id}`. */
  moodboardStructureSync: "/moodboard/structure-sync/",
  /** Structure sync issue action — append `/{video_id}/{moodboard_id}/action`. */
  moodboardStructureSyncAction: "/moodboard/structure-sync/",
  // Asset Library (org-wide). Base path `/asset-library`; company-id header required.
  assetLibraryLinkStatus: "/asset-library/link-status",
  assetLibraryMoodboardSave: "/asset-library/moodboard/save",
  assetLibraryList: "/asset-library/list",
  assetLibraryUpload: "/asset-library/upload",
  // + {asset_id} (GET detail / DELETE), {asset_id}/moodboard (GET saved set),
  //   {asset_id}/sync (POST), {asset_id}/pull-reference (POST), {asset_id}/import (POST)
  assetLibraryAsset: "/asset-library/",
  //#endregion

  //#region Shotlist APIs
  // shotlistDetails: "/shotlist/details/",
  generateShotlistReq: "/shotlist/generate/req",
  createShotlist: "/shotlist/create",
  deleteShotlistShot: "/shotlist/delete-shot/",
  addEditShotlistShot: "/shotlist/update-shot",
  addEditShotlistScene: "/shotlist/add-new-scene",
  saveSynopsis: "/shotlist/save-synopsis",
  sceneDelete: "/shotlist/scene-delete/",
  shotDelete: "/shotlist/shot-delete/",
  shotAddEntity: "/shotlist/shot/add-entity",
  shotEntitySetVariation: "/shotlist/shot-entity/set-variation",
  swapScenes: "/shotlist/swap-scenes",
  swapShots: "/shotlist/swap-shots",
  shotDescription: "/shotlist/shot-description",
  shotDisableStatus: "/shotlist/shot/disable-status",
  sceneDisableStatus: "/shotlist/scene/disable-status",
  shotCreateAltTake: "/shotlist/shot/create-alt-take",
  shotlistproductionboard: "/shotlist/production-board",
  shotlistapprovedvideos: "/shotlist/production-board/approvedvideos",
  shotlistvideoapprove: "/shotlist/video/approve",
  shotlistVideoReadyForReview: "/shotlist/video/ready-for-review",
  shotlistVideoResetStatus: "/shotlist/video/reset-status",
  shotDetail: "/shotlist/shot/detail",
  // Rich shot detail keyed by shotId (entities/dialogue/frames + all_videos when
  // include_all_videos=true). Same base as `shotDetails` — the clean, slash-
  // separated form: /shotlist/shot-detail/{shotId}.
  shotDetailComplete: "/shotlist/shot-detail/",
  // Save the Motion Builder's Shot Setup dossier edits (description, action,
  // dialogue, audio cues, narration, supers, camera move, duration).
  saveShotSetup: "/shotlist/shot-setup",
  // Motion Builder Edit Clip — compose an edit prompt from selected recipes,
  // then poll the composer job for the resulting video_prompt.
  aiVideoEditApply: "/shotlist/ai-video-edit/v2",
  aiVideoEditStatus: "/shotlist/ai-video-edit/status/",
  // Unified job-status polling — one endpoint for every render/edit/upscale/
  // frame-spec job across the list page and Motion Builder.
  jobsStatus: "/shotlist/jobs/status",
  /** Create a frame-element extraction job for shot edit-recipe target pickers. */
  createElementExtractionJob: "/shotlist/create-element-extraction-job",
  updateShotVideoParams: "/shotlist/update-shot-video-params",
  updateviewstatusvideo: "/shotlist/ai-video/updateviewstatus",
  shotImageApprove: "/shotlist/approved-storyboard-img",
  shotImageVariationDelete: "/shotlist/shot/frame/delete/",
  // shotImageReadyForReview: "/shotlist/storyboard/frame/ready-for-review",
  shotDetails: "/shotlist/shot-detail/",
  approveReadyShots: "/shotlist/approve-ready-shots/",
  changeModel: "/shotlist/shot-video-request/change-model",
  aiVideoUploadPresign: "/shotlist/ai-video/upload-presign",
  aiVideoUploadSave: "/shotlist/ai-video/upload-save",
  visualDnaSave: "/shotlist/visual-dna/save",
  videoVisualDnaCreate: "/shotlist/film-visual-classifier",
  videoLevelDnaOptions: "/master-list/video-level-dna-options",
  campaignVideoDnaUpdate: "/campaign-video/dna-update",
  campaignVideoVisualDnaReferencesUpload:
    "/campaign-video/visual-dna-references/upload",
  campaignVideoVisualDnaReferenceDelete:
    "/campaign-video/visual-dna-references/",
  campaignVideoAnalyzeReferences: "/campaign-video/analyze-references",
  campaignVideoAspectRatios: "/campaign-video/aspect-ratios",
  shotlistExcelData: "/shotlist/exceldata",
  //#endregion

  //#region Storyboard APIs
  pendingImagesGen: "/shotlist/storyboard/pending-images-gen",
  storyboardDetails: "/shotlist/storyboard-detail/",
  storyboardImageGenerate: "/shotlist/storyboard-image-gen",
  storyboardImageGenerateV2: "/shotlist/storyboard-img-genv2",
  uploadStoryImage: "/shotlist/upload-storyimage",
  importStoryImage: "/shotlist/import-storyimage",
  uploadvideorefimage: "/shotlist/upload-videorefimage",
  upscaleStoryboardImage: "/shotlist/upscale-storyboard-image",
  storyboardImageUpdateViewStatus:
    "/shotlist/storyboard-image/updateviewstatus",
  storyboardImageLlmData: "/shotlist/storyboard-image-llm-data",
  //#endregion

  //#region Video Upscale APIs
  videoUpscaleCreate: "/video-upscale/create",
  // Append the jobId: `/video-upscale/progress/${jobId}`.
  videoUpscaleProgress: "/video-upscale/progress/",
  videoUpscaleList: "/video-upscale/list",
  videoUpscaleCancel: "/video-upscale/cancel/",
  //#endregion

  //#region Voice Over
  createVoiceOverSegment: "/voiceover/create-segment",
  voiceOverDetails: "/voiceover/details/",
  voiceTTSGenerate: "/voiceover/tts-generate",
  voiceList: "/voice/list",
  checkifprevapproved: "/voice/checkifprevapproved",
  approvethetake: "/voice/approvethetake",
  unapprovethetake: "/voice/unapprovethetake",
  voicegeneratespeech: "/voice/generate-speech",
  uploadVoiceAudio: "/voice/user/upload",
  clearVoiceSegment: "/voiceover/segments-clear",

  scriptbeats: "/voice/script/beats",
  bgmsettingsdefault: "/voice/manifest/infer/bgmsettings",
  createbgmrequest: "/voice/bgm/create",
  bgmtracks: "/voice/bgm/tracks",
  checkifprevbgmapproved: "/voice/bgm/checkifprevapproved",
  approvebgmtrack: "/voice/bgm/approvetrack",
  unapprovebgmtrack: "/voice/bgm/unapprovetrack",
  uploadBgmAudio: "/voice/bgm/upload",
  voiceReadyForReview: "/voice/readyforreview",
  voiceRevokeToGenerated: "/voice/revoke-to-generated",
  bgmReadyForReview: "/voice/bgm/readyforreview",
  bgmRevokeToGenerated: "/voice/bgm/revoke-to-generated",

  createVoiceOver: "/voice/create",
  //#endregion

  //#region VideoX
  createVideox: "/shotlist/videox-create",
  videoXDetails: "/shotlist/videox-details/",
  videoXGenerate: "/shotlist/ai-video-generate",
  videoXGeneratev2: "/shotlist/ai-video-generate/v2",
  shotVideoApprove: "/shotlist/shot-video-approve",
  removeVideo: "/shotlist/ai-video-delete/",
  videoDetailsForGate: "/shotlist/video_details_for_gate/",
  videoxCreate: "/shotlist/videox-create",
  autonomousGeneration: "/autonomous-generation",
  autonomousGenerationMoodboard: "/autonomous-generation/moodboard-v2",
  autonomousGenerationStoryboard: "/autonomous-generation/storyboard",
  autonomousGenerationStoryboardV2: "/autonomous-generation/storyboard-v2",
  autonomousGenerationFetchRequest:
    "/autonomous-generation/process/fetchrequest",
  autonomousGenerationPause: "/autonomous-generation/", // + id + /pause
  autonomousGenerationResume: "/autonomous-generation/", // + id + /resume
  //#endregion

  /**
   * Subscription
   */
  //subscriptionoverview: "/subscription/billing/overview",
  subscriptionusagehistory: "/subscription/usage/history",
  subscriptioncreditpackages: "/subscription/creditpackages",
  subscriptionautocreditpackages: "/subscription/autoreloadcreditpackages",
  getautoreloadoptions: "/subscription/autoreloadoptions",
  subscriptiontopup: "/subscription/topup",
  saveautoreloadoptions: "/subscription/saveautoreloadoptions",
  getsavedautoreloadoptions: "/subscription/getautoreloadoptions",
  plancomparison: "/subscription/plancomparison",
  planlist: "/subscription/planlist",
  subscriptionensurefree: "/subscription/ensure-free",
  paymentcreatesubscription: "/payment/create-subscription",
  paymentcreatetopup: "/payment/create-topup",
  orderdetailsGet: "/payment/order-details",

  //#endregion

  //#endregion
  //subscriptionoverview: "/subscription/billing/overview",

  //#endregion
  subscriptionoverview: "/subscription/billing/overview",
  subscriptioncredits: "/subscription/billing/credits",
  billingInfoSave: "/subscription/billing-info",
  billingInfoGet: "/subscription/billing-info",
  subscriptioninvoices: "/subscription/invoices",
  invoiceDetails: "/subscription/invoice-detail",
  cancelSubscription: "/subscription/cancel",
  //#endregion

  notificationsunreadcount: "/notifications/unread-count",
  notificationlist: "/notifications/list",
  notificationmark: "/notifications/mark-read",
  companydetailsupdate: "/users/company/update",
  invite_user: "/users/invite-users/v2",
  usersupdate: "/users/update",
  resend_invite: "/users/invitation/org/resend/v2",

  //#region Workspace APIs
  // Versions
  workspaceVersionCreate: "/workspace/version/create",
  workspaceVersionList: "/workspace/version/list/", // + workspaceId
  workspaceVersionDetail: "/workspace/version/detail/", // + versionId
  workspaceVersionUpdate: "/workspace/version/update",
  workspaceVersionDelete: "/workspace/version/delete/", // + versionId
  workspaceVersionApprove: "/workspace/version/approve",
  workspaceVersionLock: "/workspace/version/lock",

  // Feedback
  workspaceFeedbackCreate: "/workspace/feedback/create",
  workspaceFeedbackList: "/workspace/feedback/list/", // + videoId
  workspaceFeedbackUpdate: "/workspace/feedback/update",
  workspaceFeedbackResolve: "/workspace/feedback/resolve",
  workspaceFeedbackDelete: "/workspace/feedback/delete/", // + feedbackId
  workspaceFeedbackAttachmentUpdate: "/workspace/feedback/attachment/update",

  // Feedback Replies
  workspaceFeedbackReplyCreate: "/workspace/feedback/reply/create",
  workspaceFeedbackReplyDelete: "/workspace/feedback/reply/delete/", // + replyId

  // Feedback Reactions
  workspaceFeedbackReactionToggle: "/workspace/feedback/reaction/toggle",

  // References
  workspaceReferenceCreate: "/workspace/reference/create",
  workspaceReferenceList: "/workspace/reference/list/", // + workspaceId
  workspaceReferenceDelete: "/workspace/reference/delete/", // + referenceId
  workspaceReferenceTypes: "/workspace/reference-types", // GET → list of ref types
  workspaceDocumentUpload: "/workspace/",
  workspacereferencesList: "/workspace/references/", // + workspaceId + "/documents" POST multipart
  workspaceCreate: "/workspace", // POST { video_id, edit_mode }
  workspaceDetails: "/workspace",
  workspaceheartbeat: "/workspace/heartbeat/details",
  workspaceAssets: "/workspace/", // + workspaceId + "/assets"
  workspaceProxyDownload: "/workspace/proxy-download", // GET ?url=<encoded>&filename=<name>
  // Share / Invite
  workspaceInvite: "/workspace/invite",
  workspaceInviteResend: "/workspace/invite/resend",
  workspaceShareLink: "/workspace/share/link",
  workspaceMembers: "/workspace/", // + unique_id + "/members" (GET)
  workspaceMemberRemove: "/workspace/", // + unique_id + "/members/" + user_id (DELETE)
  // Spatial annotations on a render-file version.
  // GET    /workspace/file/:fileId/annotation         → list
  // POST   /workspace/file/:fileId/annotation         → create
  // PATCH  /workspace/annotation/:id                  → partial update
  // DELETE /workspace/annotation/:id                  → delete
  workspaceFileAnnotation: "/workspace/file/", // + fileId + "/annotation"
  workspaceAnnotation: "/workspace/annotation/", // + id
  workspaceLogin: "/workspace/login",

  // Render Files (version upload)
  renderFilesPresignedUrl: "/render-files/presigned-url",
  renderFilesSaveMeta: "/render-files/save-meta",
  renderFilesSignedUrl: "/render-files/signed-url",
  renderFilesList: "/render-files/", // + videoId
  renderFilesDelete: "/render-files/delete/", // + id (POST)

  // Aspect Ratio
  workspaceAspectRatio: "/workspace/aspectratio", // POST + ?video_id=
  renderFilesByAspect: "/render-files/", // + {videoId}/aspectratio/{aspectRatioId}

  // Library upload — POST multipart (file + aspect_ratio_id) to
  // /workspace/{workspaceId}/raw
  workspaceRawUpload: "/workspace/", // + {workspaceId}/raw
  // Soft-delete a raw library upload —
  // DELETE /workspace/{workspaceId}/raw-uploads/{rawUploadId}
  workspaceRawUploadDelete: "/workspace/", // + {workspaceId}/raw-uploads/{id}

  // Composite preview endpoint — V/VO/MX timeline + library + edit_state
  // for ONE render version. Used on mount and aspect-ratio switch.
  //   GET  /workspace/{workspaceId}/preview?aspect_ratio_id=N[&version_id=X]
  //   PUT  /workspace/{workspaceId}/preview?aspect_ratio_id=N[&version_id=X]
  //   POST /workspace/{workspaceId}/preview/version?aspect_ratio_id=N
  workspacePreview: "/workspace/", // + {workspaceId}/preview
  workspacePreviewVersion: "/workspace/", // + {workspaceId}/preview/version
  // Lightweight version list for the v2 version chip dropdown — separate
  // from /preview because the dropdown shouldn't pay for snapshot+library.
  //   GET  /workspace/{workspaceId}/preview/versions?aspect_ratio_id=N
  workspacePreviewVersions: "/workspace/", // + {workspaceId}/preview/versions

  // Server-side rough-cut render — bake the assembled timeline (clips + VO +
  // BGM) into a single downloadable mp4. Async job; FE queues + polls.
  //   POST /workspace/{workspaceId}/render                       — V1 queue (snapshot-based)
  //   POST /workspace/{workspaceId}/render/v2                    — V2 queue (FE-supplied manifest, captures unsaved edits)
  //   GET  /workspace/{workspaceId}/render/{jobId}               — poll
  //   POST /workspace/{workspaceId}/render/{jobId}/cancel        — cancel
  //   GET  /workspace/{workspaceId}/renders?limit=&offset=       — history
  workspaceRender: "/workspace/", // + {workspaceId}/render
  workspaceRenderV2: "/workspace/", // + {workspaceId}/render/v2
  workspaceRenderJob: "/workspace/", // + {workspaceId}/render/{jobId}
  workspaceRenderJobCancel: "/workspace/", // + {workspaceId}/render/{jobId}/cancel
  workspaceRendersList: "/workspace/", // + {workspaceId}/renders
  //#endregion
  // Support
  contactSupport: "/support/contact-us",

  //#region Quick Create
  qcModels: "/quick-create/models",
  qcAspectRatios: "/quick-create/aspect-ratios",
  qcAttributes: "/quick-create/attributes",
  qcOptionCatalog: "/quick-create/option-catalog/", // + {name}
  qcEditRecipes: "/quick-create/edit-recipes",
  qcRename: "/quick-create/", // + {type}/{id}
  qcFrameGenerate: "/quick-create/frame/generate",
  qcFrame: "/quick-create/frame/", // + {id}
  qcFrameUploadUrl: "/quick-create/frame/upload-url",
  qcFrameUpload: "/quick-create/frame/upload",
  qcFrameDirector: "/quick-create/frame/director",
  qcClipGenerate: "/quick-create/clip/generate",
  qcClipUploadUrl: "/quick-create/clip/upload-url",
  qcClipUpload: "/quick-create/clip/upload",
  qcClipLibraryFrames: "/quick-create/clip/library-frames",
  qcClip: "/quick-create/clip/", // + {id}
  qcClipEdit: "/quick-create/clip/", // + {id}/edit
  qcClipApprove: "/quick-create/clip/", // + {id}/approve
  qcClipKeep: "/quick-create/clip/", // + {id}/keep
  qcClipExport: "/quick-create/clip/", // + {id}/export
  qcCharacterGenerate: "/quick-create/character/generate",
  qcCharacterUploadUrl: "/quick-create/character/upload-url",
  qcCharacterUpload: "/quick-create/character/upload",
  qcCharacter: "/quick-create/character/", // + {id} — also location/prop seen
  qcJobsStatus: "/quick-create/jobs/status",
  qcJobCancel: "/quick-create/jobs/", // + {id}/cancel
  qcLibrary: "/quick-create/library",
  qcLibraryCounts: "/quick-create/library/counts",
  qcLibraryUpload: "/quick-create/library/upload",
  qcReferenceAssets: "/quick-create/reference-assets",
  qcReferenceAssetsV2: "/quick-create/reference-assets/v2",
  /** Scene Visualiser — `/quick-create/scene` (+ `/visualise`, `/:id`, shot actions, …) */
  qcScene: "/quick-create/scene/",
  qcSceneVisualise: "/quick-create/scene/visualise",
  //#endregion
};
